import React, { useState } from "react"
import FormField from "../../Components/FormField/FormField"
import Modal from "../../Components/Modal/Modal"
import ConfirmButton from "../../Components/Buttons/ConfirmButton"
import CancelButton from "../../Components/Buttons/CancelButton"
import { API } from "../../API"
import { notify } from "react-notify-toast"

function ConfirmPasswordPopup({
  header,
  onClose,
  onConfirm,
  children,
  role,
  ...props
}) {
  const [password, setPassword] = useState("")

  const onSubmit = async () => {
    const user = {
      id: localStorage.userID,
      role: role,
      password: password,
    }
    await API.confirmPassword({ user: user })
      .then((res) => {
        onConfirm()
        onClose()
      })
      .catch((err) => {
        notify.show("Wrong Password", "error")
        console.log(err)
      })
  }

  return (
    <Modal
      header={header}
      onClose={onClose}
      className="delete-modal"
      {...props}
    >
      <div>{children}</div>

      <FormField
        label="Input Current Password"
        type="password"
        className="my-5"
        placeholder="Enter current password"
        onChange={(e) => setPassword(e.target.value)}
      />

      <div className="row qualification-footer">
        <div className="col-md-6">
          <CancelButton onClick={onClose}>Cancel</CancelButton>
        </div>
        <div className="col-md-6">
          <ConfirmButton onClick={onSubmit}>Confirm</ConfirmButton>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmPasswordPopup
